import { Component, Inject, Input } from '@angular/core';

import { Store } from '@ngrx/store';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../../../base/store/state';
import { AlertType } from '../../../../alerts/models';
import { RewardTokensActions } from '../../../../reward-tokens/actions';
import { RewardTokenContext } from '../../../../reward-tokens/reward-tokens.model';
import { ErrorOrigin } from '../../../errors/betslip-error';
import { ErrorViewModel } from '../../../models/models';
import { getErrorAlertType, getErrorMessage } from '../../../services/utils/betslip-errors-display-utils';

@Component({
    selector: 'bs-linear-errors-list',
    templateUrl: './linear-errors-list.component.html',
    styleUrls: ['./linear-errors-list.component.scss'],
    standalone: false,
})
export default class LinearErrorsListComponent {
    @Input() viewModel: ErrorViewModel[];
    @Input() tokensContext?: RewardTokenContext;
    @Input() shouldShowDefaultBetNotPlacedTitle = false;

    trackingSource?: { [key: string]: string };

    private readonly messages: {
        betNotPlaced: string;
    };

    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        private store: Store<IBetslipRootState>,
    ) {
        const messages = messageProvider.getMessages();
        this.messages = {
            betNotPlaced: messages.common.BetNotPlaced,
        };
    }

    redirectFromErrorMessage($event: any): void {
        if (!$event?.target?.className) {
            return;
        }

        if ($event.target.className.indexOf('remove-token') < 0) {
            return;
        }

        if (!this.tokensContext) {
            this.store.dispatch(RewardTokensActions.deselectAllToken({ trackingSource: this.trackingSource }));

            return;
        }

        this.store.dispatch(
            RewardTokensActions.deselectTokenForContext({
                payload: {
                    betslipType: this.tokensContext.betslipType,
                    pickId: this.tokensContext.pickId,
                },
            }),
        );
    }

    getMessage(error: ErrorViewModel): string | null {
        return getErrorMessage(error);
    }

    getTitle(error: ErrorViewModel): string | null {
        const message = error.message;

        const isBetPlacementError = error.error.origin === ErrorOrigin.BetPlacement;

        if (!message || typeof message === 'string') {
            return isBetPlacementError ? this.messages.betNotPlaced : null;
        }

        return isBetPlacementError && this.shouldShowDefaultBetNotPlacedTitle ? this.messages.betNotPlaced : message.title;
    }

    getType(error: ErrorViewModel): AlertType {
        return getErrorAlertType(error.error);
    }
}
